<script>
import formatDate from '@utils/format-date'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { courseComputed, authComputed, courseListMethod } from '@state/helpers'

export default {
  page: {
    title: 'Course Content',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    Table,
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      show: false,
      courseId: '',
      // subCategoryList: []
      fields: [
        {
          value: 'title',
          text: 'Title',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'title', label: 'Title', colType: 'default' },
        { key: 'demo_doc', label: 'Demo Document', colType: 'default' },
        { key: 'demo_video', label: 'Demo Video', colType: 'default' },
        { key: 'content', label: 'Course Content', colType: 'content' },
        { key: 'createdAt', label: 'Published On ', colType: 'date' },
      ],
      courseContent: [],
      courseBatchExist: false,
      addedBy: '',
    }
  },
  computed: {
    ...courseComputed,
    ...authComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getCourseInfo()
  },
  methods: {
    ...courseListMethod,
    getCourseInfo() {
      let Data = {}
      Data.id = this.$route.params.courseId
      this.getCourse({ Data }).then((data) => {
        this.addedBy = data.added_by
        const filter = {
          page: this.$route.query.page ? this.$route.query.page : 1,
          limit: 10,
          sort: 'sort_order',
          order: '-1',
          course_id: this.$route.params.courseId,
        }

        this.fetchCourseBatchList({ filter }).then((list) => {
          if (list.length >= 1) {
            this.courseBatchExist = true
            this.fetchCourseSessionList({ filter }).then((data) => {
              this.isLoading = false
              this.courseContent = data
            })
          }
        })
      })
    },
    formatDates(date) {
      return formatDate(date)
    },
    handleRoute(path) {
      this.$router.push({ path: path })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            <button
              v-if="
                role !== 'hod' &&
                role !== 'teacher' &&
                courseBatchExist &&
                addedBy === currentUser.user._id
              "
              id="show-modal"
              class="btn btn-info"
              @click="
                handleRoute(`/add-course-content/${$route.params.courseId}`)
              "
              ><i class="ti-plus"></i>Add Course Session</button
            >
            <br /><br />
            <Table
              :items="courseContent.docs ? courseContent.docs : []"
              :table-name="'course-content'"
              :fields="fields"
              :bordered="true"
              :viewbtn="true"
              :deletebtn="true"
              :editbtn="true"
              :editcoursecontent="true"
              :per-page="courseContent.limit"
              :total-rows="courseContent.totalDocs"
              :current-page="courseContent.page"
              :display-fields="displayFields"
              :total-page="courseContent.totalPages"
              :paging-counter="courseContent.pagingCounter"
            ></Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}
.showError {
  color: red;
}
.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  /* font-family: inherit; */
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
